import { render } from "./AdminPagination.vue?vue&type=template&id=6360f6ea&scoped=true"
import script from "./AdminPagination.vue?vue&type=script&lang=js"
export * from "./AdminPagination.vue?vue&type=script&lang=js"

import "./AdminPagination.vue?vue&type=style&index=0&id=6360f6ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6360f6ea"]])

export default __exports__